import { AppResponse } from "src/models/app-response";
import { Notification, NotificationUpdateBody, UpdateNotificationRequest, } from "src/models/notification";
import { endpoints } from "src/utils/api-endpoints";
import axios from 'src/utils/axios';

export async function getNotifications(): Promise<AppResponse<Notification[]>> {
  const URL = `${endpoints.notification.getNotifications}`;
  try {
    const response = await axios.get(URL);

    return response.data;
  } catch (error) {
    console.error('Failed to get groups:', error);
    return {success: false, data: [], error}
  }
}

export async function updateNotification(updatedData: Partial<NotificationUpdateBody>): Promise<AppResponse<Notification[]>>{
  const URL = `${endpoints.notification.editNotification}`;
  try {
    const response = await axios.post(URL, updatedData);
    return response.data;
  } catch (error) {
    console.error('Failed to get groups:', error);
    return {success: false, error}
  }
}


export async function UpdateNotification( resendData: UpdateNotificationRequest ): Promise<AppResponse<unknown>> {
  const URL = `${endpoints.notification.resendNotification}`;
  try {
    const response = await axios.post(URL, resendData);
    return {
      success: true,
      data: response.data.document,
    };
  } catch (error) {
    console.error('Failed to resend notification:', error);
    return { success: false, error: error.message || 'Unknown error' };
  }
}

export async function broadcastNotification(title: string, message: string): Promise<AppResponse<Notification>> {
  const URL = endpoints.notification.broadcast;
  try {
    const response = await axios.post(URL, { title, message });
    return response.data;
  } catch (error) {
    console.error('Failed to broadcast notification:', error);
    return { success: false, data: undefined, error };
  }
}

  // export async function clearNotifications(): Promise<AppResponse<{ cleared:boolean }>>{
  //   try{
  //       const response = await axios.delete(endpoints.notification.clear);
  //       return response.data;
  //   }catch(error){
  //     console.error('Failed to clear Notifications:', error);
  //     return { success:false, data: undefined, error}
  //   }
  // }